import { preventBubblingEvent } from '@mote/helpers/browser'
import { KeyboardKey } from '@mote/helpers/constants'
import { Button } from '@mote/ui'
import React from 'react'
import styled from 'styled-components'
import { useRecordReplySidebar } from './RecordReplySidebar.context'

export const ToggleRecordReplySidebarButton = ({ className, text }) => {
  const { state, toggle } = useRecordReplySidebar()
  const buttonText = React.useMemo(() => {
    if (text) return text

    let newText = `Reply to ${state.mote?.parentMote.createdByGreeting}`

    if (state.mote?.replyMotes.length > 0) {
      newText += ` (${state.mote?.replyMotes.length})`
    }

    return newText
  }, [text, state.mote])

  if (state.isOpen || !state.mote?.canReply) return null

  return (
    <StyledButton
      aria-label='Reply to'
      size='sm'
      text={buttonText}
      onClick={event => {
        preventBubblingEvent(event)
        toggle()
      }}
      onKeyDown={event => {
        switch (event.keyCode) {
          case KeyboardKey.Space:
          case KeyboardKey.Enter:
            preventBubblingEvent(event)
            toggle()
            break
        }
      }}
      className={className}
    />
  )
}

const StyledButton = styled(Button)`
  & .button-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
